<div class="flex-row justify-content-between">
  <div class="flex-child custom-col-md">
    <energy-circle-chart
      data-testid="analysis-autarky-chart"
      [value]="autarkyChartValue"
      [colors]="['#2CC84D', '#EDEDED']"
      [status]="status"
      role="img"
      [attr.aria-label]="
        ('ENERGY_COCKPIT.ENERGY_CHART.BUTTON_LABEL.' + ConsumptionType.AUTARKY
          | translate) +
        ' ' +
        autarkyChartValue +
        '%'
      "
    ></energy-circle-chart>
    <energy-dialog-open-button
      data-testid="analysis-autarky-button"
      [series]="autarkyChartItems"
      [status]="status"
      [type]="ConsumptionType.AUTARKY"
      [accessibilityLabel]="
        'ACCESSIBILITY.ENERGY_COCKPIT.ENERGY_CHART.AUTARKY_BUTTON'
      "
    ></energy-dialog-open-button>
  </div>
  <div class="flex-child custom-col-md">
    <energy-circle-chart
      data-testid="analysis-self-consumption-chart"
      [value]="consumptionChartValue"
      [colors]="['#FBC640', '#EDEDED']"
      [status]="status"
      role="img"
      [attr.aria-label]="
        ('ENERGY_COCKPIT.ENERGY_CHART.BUTTON_LABEL.' +
          ConsumptionType.SELF_CONSUMPTION | translate) +
        ' ' +
        consumptionChartValue +
        '%'
      "
    ></energy-circle-chart>
    <energy-dialog-open-button
      data-testid="analysis-self-consumption-button"
      [series]="consumptionChartItems"
      [status]="status"
      [type]="ConsumptionType.SELF_CONSUMPTION"
      [accessibilityLabel]="
        'ACCESSIBILITY.ENERGY_COCKPIT.ENERGY_CHART.SELF_CONSUMPTION_BUTTON'
      "
    ></energy-dialog-open-button>
  </div>
  <div
    class="flex-child custom-col-md"
    *ngIf="environmentStatistics?.co2Emission?.unit !== 'n/a'"
  >
    <vi-environment
      [environmentStatistics]="environmentStatistics"
      [status]="status"
    ></vi-environment>
  </div>
</div>
